<div
  class="bar mat-body-2"
  [ngClass]="fixedPosition ? 'position-' + fixedPosition : ''"
  [innerHTML]="'common.messages.useChromeBrowser' | translate"
></div>
